import React from 'react';
import NewTermAgreementGroup from '../../../common/components/NewTermAgreementGroup';
import { AgreementSrc } from '../../../common/configs/values';

/**
 * 약관 동의 섹션 공통 컴포넌트
 * @param {Object} props
 * @param {Object} props.agreement - 약관 동의 상태
 * @param {Function} props.onCheckBox - 체크박스 핸들러
 */
function AgreementSection({ agreement, onCheckBox }) {
    const allAgree = Object.values(agreement).every((value) => value);

    const {
        wink_terms_agreement,
        private_info_agreement,
        marketing_and_information_receive_agreement,
        advertising_information_receive_agreement,
    } = agreement;

    const requiredTerms = [
        {
            id: 'wink-terms-agreement',
            label: '서비스 이용약관 동의',
            url: AgreementSrc.winkAgree,
            checked: wink_terms_agreement,
            onChange: (e) => onCheckBox(e, 'wink_terms_agreement'),
        },
        {
            id: 'private-info-agreement',
            label: '개인정보 수집 및 활용 동의',
            url: AgreementSrc.privacyConsent,
            checked: private_info_agreement,
            onChange: (e) => onCheckBox(e, 'private_info_agreement'),
        },
    ];

    const optionalTerms = [
        {
            id: 'marketing-agreement',
            label: '마케팅 목적 활용 동의',
            url: AgreementSrc.marketingPolicy,
            checked: marketing_and_information_receive_agreement,
            onChange: (e) =>
                onCheckBox(e, 'marketing_and_information_receive_agreement'),
        },
        {
            id: 'advertising-agreement',
            label: '광고성 정보 수신 동의',
            url: AgreementSrc.advertisingPolicy,
            checked: advertising_information_receive_agreement,
            onChange: (e) =>
                onCheckBox(e, 'advertising_information_receive_agreement'),
        },
    ];

    return (
        <NewTermAgreementGroup
            multiCheckContext={{
                label: '모두 동의하고 혜택도 받기',
                checked: allAgree,
                value: false,
                onChange: (e) => onCheckBox(e, 'all'),
            }}
            requiredTerms={requiredTerms}
            optionalTerms={optionalTerms}
        />
    );
}

export default AgreementSection;
